import React from 'react';
import {Col, Grid, Row} from 'react-styled-flexboxgrid';

import {H1, H4} from '../../atoms/TextComponents';
import FlexWrapper from './FlexWrapper';
import {HeroImageWrapper, HeroSectionDark, HeroSectionLight} from './HeroSection';
import {Button, ExternalLinkButton} from '../../atoms/Button';
import {GlobalContext} from '../../context/GlobalContext';
import {Video} from '../Video';
import Img from 'gatsby-image';

const HeroComponent = ({content, variant, isHomepage}) => {

  return variant === 'dark' ? (
      <HeroSectionDark hasBackground={isHomepage}>
        <Grid>

          <Row>
            <Col xs={12} sm={6}>
              <FlexWrapper column justify="space-between" align="start">
                <div>
                  <H1 color="white">
                    {content.tagline}
                  </H1>
                  <H4 color="gray100">{content.description}</H4>
                </div>
                <GlobalContext.Consumer>
                  {globalContext =>
                      <ExternalLinkButton primary href="https://www.dixa.com/demo">Book a Demo</ExternalLinkButton>
                  }
                </GlobalContext.Consumer>
              </FlexWrapper>
            </Col>

            <Col xs={12} sm={6}>
              {
                content.promoVideo ?
                    (
                        <FlexWrapper column justify="center" align="center">
                          <Video videoSrc={content.promoVideo.file.url}
                                 thumbnailSrc={content.promoVideoThumbnail}
                                 text="Discover Miuros" isWide={true}/>
                        </FlexWrapper>
                    ) :
                    (
                        <HeroImageWrapper>
                          <Img fluid={content.heroImage.fluid}/>
                        </HeroImageWrapper>
                    )
              }
            </Col>
          </Row>

        </Grid>
      </HeroSectionDark>
  ) : (
      <HeroSectionLight>
        <Grid>

          <Row>
            <Col xs={12} sm={6}>
              <FlexWrapper column justify="space-between" align="start">
                <div>
                  <H1>
                    {content.tagline}
                  </H1>
                  <H4 color="gray600">{content.description}</H4>
                </div>
                <GlobalContext.Consumer>
                  {globalContext =>
                      <ExternalLinkButton primary href="https://www.dixa.com/demo">Book a Demo</ExternalLinkButton>
                  }
                </GlobalContext.Consumer>
              </FlexWrapper>
            </Col>

            <Col xs={12} sm={6}>
              {
                content.promoVideo ?
                    (
                        <FlexWrapper column justify="center" align="center">
                          <Video videoSrc={content.promoVideo.file.url}
                                 thumbnailSrc={content.promoVideoThumbnail}
                                 text="Discover Miuros" isWide={true}/>
                        </FlexWrapper>
                    ) :
                    (
                        <HeroImageWrapper>
                          <Img fluid={content.heroImage.fluid}/>
                        </HeroImageWrapper>
                    )
              }
            </Col>
          </Row>

        </Grid>
      </HeroSectionLight>
  );
};

export default HeroComponent;
